module.exports = __webpack_public_path__ + "static/media/calendar.ae6a9ace.svg";